export default __webpack_public_path__ + "static/media/catEggs.b441f930.svg";